var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoriasIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2308 2.6087H0.769231C0.348718 2.6087 0 2.01739 0 1.30435C0 0.591304 0.348718 0 0.769231 0H19.2308C19.6513 0 20 0.591304 20 1.30435C20 2.01739 19.6513 2.6087 19.2308 2.6087Z",
    fill: "#1A3D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2308 11.304H0.769231C0.348718 11.304 0 10.7127 0 9.99966C0 9.28662 0.348718 8.69531 0.769231 8.69531H19.2308C19.6513 8.69531 20 9.28662 20 9.99966C20 10.7127 19.6513 11.304 19.2308 11.304Z",
    fill: "#1A3D82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2308 19.9993H0.769231C0.348718 19.9993 0 19.408 0 18.695C0 17.9819 0.348718 17.3906 0.769231 17.3906H19.2308C19.6513 17.3906 20 17.9819 20 18.695C20 19.408 19.6513 19.9993 19.2308 19.9993Z",
    fill: "#1A3D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriasIcon);
export default __webpack_public_path__ + "static/media/categoriasIcon.07d4b90287b41bc2d21a6f15f4446ebc.svg";
export { ForwardRef as ReactComponent };